import { Children } from "react";
export function hasButton({ children, href, onClick }) {
    const hasChildren = Children.count(children) > 0;
    return hasChildren && Boolean(href || onClick);
}
//# sourceMappingURL=hasButton.js.map